export default __webpack_public_path__ + "static/media/Artboard 7.a746c93d.png";